import { IBaseComponentProps } from "../props/IBaseComponentProps";
import Styles from './NSLine.module.css';

export interface NSLineProps extends IBaseComponentProps
{ }

export function NSLine(props: NSLineProps)
{
	return (
		<div id={props.id} style={props.style} className={`${Styles.ns_line_container} `} >
			<hr className={`${Styles.ns_line} ${props.classList?.join(" ") ?? ""}`} />
		</div>
	);
}